import React, { useState, useEffect, useRef } from "react";
import PlaybackButton from "../PlaybackButton";
import { SocialWrapper } from "./Social.styles";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import socialframe from "../../../../assets/images/socialframe.png";
import card from "../../../../assets/pages/landing/Social/card.png";
import { fetchYouTubeVideoTitles } from "../../../../utils/youtube";
import { requestExternalNavigation } from "../../../../utils/externalNavigation";

const videos = [
  {
    id: 1,
    videoId: "PWtV852f0Us",
    videoUrl: "https://www.youtube.com/watch?v=PWtV852f0Us",
  },
  {
    id: 2,
    videoId: "rjigziCsbsM",
    videoUrl: "https://www.youtube.com/watch?v=rjigziCsbsM",
  },
  {
    id: 3,
    videoId: "usS2ToUUfVw",
    videoUrl: "https://www.youtube.com/watch?v=usS2ToUUfVw",
  },
  {
    id: 4,
    videoId: "UfT3-hIGPsE",
    videoUrl: "https://www.youtube.com/watch?v=UfT3-hIGPsE",
  },
];

const Social = () => {
  const [isPaused, setIsPaused] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [videoTitles, setVideoTitles] = useState({});
  const autoplayRef = useRef(null);
  const radioRefs = useRef([]);

  const handleStoryKeyDown = (event, index) => {
    let nextIndex;
    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        nextIndex = (index + 1) % videos.length;
        break;
      case "ArrowLeft":
      case "ArrowUp":
        nextIndex = (index + videos.length - 1) % videos.length;
        break;
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = videos.length - 1;
        break;
      default:
        return;
    }
    event.preventDefault();
    setCurrentIndex(nextIndex);
    radioRefs.current[nextIndex]?.focus();
  };

  const currentVideo = videos[currentIndex];
  const currentVideoTitle =
    videoTitles[currentVideo.videoId] || "Loading video title...";

  useEffect(() => {
    const controller = new AbortController();

    fetchYouTubeVideoTitles(
      videos.map((video) => video.videoId),
      controller.signal,
    )
      .then(setVideoTitles)
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Unable to load YouTube video titles", error);
        }
      });

    return () => controller.abort();
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? videos.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === videos.length - 1 ? 0 : prev + 1
    );
  };

  // Autoplay carousel: cycles every 5s unless paused
  useEffect(() => {
    if (autoplayRef.current) {
      clearInterval(autoplayRef.current);
      autoplayRef.current = null;
    }

    if (!isPaused) {
      autoplayRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
      }, 5000);
    }

    return () => {
      if (autoplayRef.current) {
        clearInterval(autoplayRef.current);
        autoplayRef.current = null;
      }
    };
  }, [isPaused]);

  return (
    <SocialWrapper onFocusCapture={() => setIsPaused(true)}>
      <h2 className="title text-5xl font-bold mx-auto text-center">Our Success Stories</h2>

      <img className="background-card" src={card} alt="" />

      <div className="carousel-content">
        <button type="button" className="nav-btn left" onClick={handlePrev} aria-label="Previous success story" title="Previous success story">
          <FiChevronLeft aria-hidden="true" />
          <span className="sr-only">Previous success story</span>
        </button>

        <div className="post-container">
          <img className="frame" src={socialframe} alt="Frame" />

          <a href={currentVideo.videoUrl} target="_blank" rel="noopener noreferrer" aria-label={`Open success story on YouTube in a new tab: ${currentVideoTitle}`}>
          <img
            className="thumbnail"
            src={`https://img.youtube.com/vi/${currentVideo.videoId}/hqdefault.jpg`}
            alt={currentVideoTitle}
          />
          </a>

          <button
            type="button"
            className="play-btn"
            onClick={() => {
              requestExternalNavigation(currentVideo.videoUrl);
            }}
            aria-label={`Open success story on YouTube in a new tab: ${currentVideoTitle}`}
          >
            ▶
          </button>

          <h3 className="video-title">{currentVideoTitle}</h3>
        </div>

        <button type="button" className="nav-btn right" onClick={handleNext} aria-label="Next success story" title="Next success story">
          <FiChevronRight aria-hidden="true" />
          <span className="sr-only">Next success story</span>
        </button>
      </div>

      <div className="pagination">
        <div className="story-radio-group" role="radiogroup" aria-label="Choose a success story">
        {videos.map((_, index) => (
          <button
            key={index}
            ref={(element) => { radioRefs.current[index] = element; }}
            type="button"
            role="radio"
            aria-checked={index === currentIndex}
            tabIndex={index === currentIndex ? 0 : -1}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
            onKeyDown={(event) => handleStoryKeyDown(event, index)}
            aria-label={`Show success story ${index + 1}`}
          >
            <span className="sr-only">Show success story {index + 1}</span>
          </button>
        ))}
        </div>
        <PlaybackButton paused={isPaused} onClick={() => setIsPaused((prev) => !prev)}
          label="success stories slideshow" style={{ position: "absolute", left: "calc(100% + 10px)", top: "50%", transform: "translateY(-50%)", width: 24, height: 24, background: "#173f86", color: "#ffffff", borderColor: "#173f86" }} />
      </div>

    </SocialWrapper>
  );
};

export default Social;
